import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { createCardRenderer } from "./card-viewer.js";
const pluginCardViewer = (config) => {
  const nodeViewRenderers = {
    [Node_Type.CARD]: createCardRenderer({
      pageFormat: config?.pageFormat,
      mode: config?.mode ?? "viewer",
      renderCardHeader: config?.renderCardHeader,
      cardIndexOffset: config?.cardIndexOffset
    })
  };
  return {
    config: { ...config },
    type: Node_Type.CARD,
    nodeViewRenderers
  };
};
export {
  pluginCardViewer
};
//# sourceMappingURL=viewer.js.map
